/**
 * Shared token-based search matching for user lists (students, staff, parents).
 *
 * Splits the query on whitespace and requires EVERY token to appear somewhere in
 * the provided haystack fields. This makes "Prénom Nom", "Nom Prénom", extra or
 * trailing spaces, and mixed case all work — matching the backend search rule so
 * the client-side filter never contradicts the server results.
 */

/** Build a single lowercase haystack string from arbitrary field values. */
export function buildHaystack(fields: Array<string | null | undefined>): string {
  return fields.filter(Boolean).join(' ').toLowerCase();
}

/**
 * Returns true when every whitespace-separated token of `query` is a substring
 * of `haystack`. An empty/whitespace-only query matches everything.
 */
export function matchesAllTokens(query: string, haystack: string): boolean {
  const tokens = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;
  return tokens.every((token) => haystack.includes(token));
}
